var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 5.99992H18V3.33325H6V5.99992H4.66667C3.95942 5.99992 3.28115 6.28087 2.78105 6.78097C2.28095 7.28106 2 7.95934 2 8.66658V15.9999H4.61333V14.7266H3.33333V8.66658C3.33333 8.31296 3.47381 7.97382 3.72386 7.72378C3.97391 7.47373 4.31304 7.33325 4.66667 7.33325H19.3333C19.687 7.33325 20.0261 7.47373 20.2761 7.72378C20.5262 7.97382 20.6667 8.31296 20.6667 8.66658V14.6666H19.3867V15.9999H22V8.66658C22 7.95934 21.719 7.28106 21.219 6.78097C20.7189 6.28087 20.0406 5.99992 19.3333 5.99992ZM16.6667 5.99992H7.33333V4.66659H16.6667V5.99992Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12H5.33366C5.15685 12 4.98728 12.0702 4.86225 12.1953C4.73723 12.3203 4.66699 12.4899 4.66699 12.6667C4.66699 12.8435 4.73723 13.013 4.86225 13.1381C4.98728 13.2631 5.15685 13.3333 5.33366 13.3333H6.00033V21.3333H18.0003V13.3333H18.667C18.8438 13.3333 19.0134 13.2631 19.1384 13.1381C19.2634 13.013 19.3337 12.8435 19.3337 12.6667C19.3337 12.4899 19.2634 12.3203 19.1384 12.1953C19.0134 12.0702 18.8438 12 18.667 12ZM16.667 20H7.33366V13.3333H16.667V20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.69336H19.3333V10.0267H18V8.69336Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.c861c780.svg";
export { ForwardRef as ReactComponent };